// extracted by mini-css-extract-plugin
var _1 = "src-components-common-Navigation-module__nav";
export { _1 as "nav" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"nav\":\"src-components-common-Navigation-module__nav\"}";
        // 1771440568707
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  